export default "__VITE_ASSET__CtcFK06l__"